import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateChat from "./UpdateChat";
import { config } from "../../../../config";

const apiUrl = config.apiUrl;
const ViewChat = () => {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingChat, setEditingChat] = useState(null);
  const [formData, setFormData] = useState({
    slug: "",
    name: "",
    email: "",
    whatsapp: "",
    message: "",
    messageTime: "",
  });

  // Fetch chat entries from API
  useEffect(() => {
    const fetchChats = async () => {
      try {
        const response = await axios.get(`${apiUrl}/chats`);
        setChats(response.data.chats);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching chats:", err);
        setError("Failed to load chats.");
        setLoading(false);
      }
    };

    fetchChats();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
      try {
        await axios.delete(`${apiUrl}/chatdelete/${id}`);
        setChats((prev) => prev.filter((item) => item.id !== id));
      } catch (err) {
        console.error("Error deleting entry:", err);
        setError("Failed to delete entry.");
      }
    }
  };

  // Handle Edit Button Click
  const handleEditClick = (chat) => {
    setEditingChat(chat.id);
    setFormData({
      slug: chat.slug,
      name: chat.name,
      email: chat.email,
      whatsapp: chat.whatsapp,
      message: chat.message,
      messageTime: chat.messageTime,
    });
  };

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingChat) {
      setError("No entry selected for editing.");
      return;
    }

    try {
      await axios.put(`${apiUrl}/chatsupdate/${editingChat}`, formData);
      alert("Chat entry updated successfully");
      setChats((prev) =>
        prev.map((item) =>
          item.id === editingChat ? { ...item, ...formData } : item
        )
      );
      setEditingChat(null); // Clear editing state
    } catch (err) {
      console.error("Error updating chat entry:", err);
      setError("Failed to update entry.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Chat List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Name</th>
            <th className="border border-gray-300 px-4 py-2">Email</th>
            <th className="border border-gray-300 px-4 py-2">WhatsApp</th>
            <th className="border border-gray-300 px-4 py-2">Message</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {chats.map((item) => (
            <tr key={item.id}>
              <td className="border border-gray-300 px-4 py-2">{item.name}</td>
              <td className="border border-gray-300 px-4 py-2">{item.email}</td>
              <td className="border border-gray-300 px-4 py-2">{item.whatsapp}</td>
              <td className="border border-gray-300 px-4 py-2">{item.message}</td>
              <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleEditClick(item)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(item.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingChat && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateChat
              formData={formData}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              loading={loading}
              error={error}
              onCancel={() => setEditingChat(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewChat;
